export * from './regulation.page'
